import React from "react";
import SEO from "components/SEO";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { SectionHeading } from "components/misc/Headings";
import Layout from "components/layouts/Layout";
import SingleColumn from "components/faqs/SingleColumn.js";
import GlobalStyles from '../styles/GlobalStyles';


const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900 mb-10`;
const Text = styled.div`
  ${tw`text-lg  text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
  ul {
    ${tw`list-disc list-inside`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;

export default ({ headingText = "شعبہ جات" }) => {
  return (
    <>
    <SEO title="Departments" description="Explore the departments of Jamia Mohammadia Arabia — Arabic, Islamic studies, Dawah, and modern education programs." path="/departments" />
    <GlobalStyles/>
    <Layout>
     {/* <AnimationRevealPage> */}
    
      {/* <Header /> */}
      <SingleColumn/>
      
      <Container>
        <ContentWithPaddingXl>
         
          

 
 




        </ContentWithPaddingXl>
      </Container>

      
      {/* <Footer /> */}
    {/* </AnimationRevealPage> */}
    </Layout>
    
    </>
  );
};
